import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';

import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'
import { language } from './Language';
import { color } from "../../../WEBContent/Color";
import { icon } from "../../../WEBContent/Icon"

// NOTA: continua a fazer falta para o Tipo de Competição, que na base de
// dados só guarda o value (ex: "internacional"), não o label.
const tipo_competicao_lista = [
    { value: 'campeonato_nacional', label: 'Campeonato Nacional' },
    { value: 'campeonato_regional', label: 'Campeonato Regional' },
    { value: 'taca', label: 'Taça' },
    { value: 'torneio', label: 'Torneio' },
    { value: 'internacional', label: 'Internacional' },
    { value: 'outro', label: 'Outro' },
];

const get_label = (lista, value) => lista.find(o => o.value === value)?.label ?? value ?? '';

// Modalidades e Escalões já vêm gravados como array de {label, value},
// por isso basta juntar os labels — sem precisar de nenhuma lista local.
const join_labels = (arr) => (Array.isArray(arr) ? arr.map(el => el?.label ?? el).filter(Boolean).join(', ') : '') || '-';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])

    const [, setRefresh] = useState(0)

    const [filteredData, setFilteredData] = useState(data);

    const fetch_id_info = async () => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                setData(res.data)
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create === false) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit === false) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove === false) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create === false) {
                            aux.create = node.create
                        }
                        if (aux.edit === false) {
                            aux.edit = node.edit
                        }
                        if (aux.remove === false) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    set_dados(permissions.current = aux)
                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {
        setFilteredData(data);
    }, [data]);

    useEffect(() => {

        (async () => {

            await fetch_id_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: color.corPrimaria.rgb,
            cancelButtonColor: color.corVermelha.rgb,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            setData(prev => prev.filter(el => el.id !== id))
                            setRefresh(r => r + 1)
                        })
                        .catch(error => console.log(error))
                }
            })

    }

    const columns = [
        {
            name: language[lang].competicao ?? 'Competição',
            selector: 'info.name',
            width: '16%',
            minWidth: '150px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].tipo_competicao ?? 'Tipo de Competição',
            selector: 'info.tipo_competicao',
            width: '12%',
            cell: row => <span>{get_label(tipo_competicao_lista, row.info?.tipo_competicao)}</span>,
            sortable: true,
            left: true,
        },
        {
            name: language[lang].modalidades ?? 'Modalidades',
            selector: 'info.modalidades',
            width: '14%',
            cell: row => <span>{join_labels(row.info?.modalidades)}</span>,
            sortable: false,
            left: true,
        },
        {
            name: language[lang].escaloes ?? 'Escalão(ões)',
            selector: 'info.escaloes',
            width: '12%',
            cell: row => <span>{join_labels(row.info?.escaloes)}</span>,
            sortable: false,
            left: true,
        },
        {
            name: language[lang].epoca ?? 'Época',
            selector: 'info.epoca',
            width: '9%',
            minWidth: '90px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].inicio ?? 'Início',
            selector: 'info.data_inicio',
            width: '9%',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].fim ?? 'Fim',
            selector: 'info.data_fim',
            width: '9%',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].local ?? 'Localidade',
            selector: row =>
                `${row.info?.localidade_competicao ?? ''} ${row.info?.localidade ?? ''}`,
            sortable: true,
            left: true,
            width: '12%',
            cell: row => (
                <span>
                    {[row.info?.localidade_competicao, row.info?.localidade]
                        .filter(Boolean)
                        .join(', ') || '-'}
                </span>
            ),
        },
        {
            name: '',
            right: true,
            export: false,
            width: '10%',
            minWidth: '110px !important',
            cell: row =>
                <span>
                    <Link
                        className="button button-update button-view d-none"
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        replace
                        aria-label="View Competição"
                    >
                        <i className="bi bi-eye"></i>
                    </Link>

                    {permissions.current !== null && (permissions.current.edit) ? (
                        <Link
                            className="button button-update"
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                            aria-label="Edit Competição"
                        >
                            <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {permissions.current !== null && permissions.current.remove ? (
                        <button
                            className="button button-delete"
                            onClick={() => apagar(row['id'])}
                            aria-label="Delete Competição"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )
                        :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].competicao ?? 'Competição'}</h2>
                <p>{language[lang].competicao_list ?? 'Lista de Competições'}</p>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-5">
                                        <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>

                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}